import { Component, OnChanges, OnInit, TemplateRef, input, contentChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import '../../extensions/date.extension';

@Component({
    selector: 'pcp-calendar',
    templateUrl: './pcpcalendar.component.html',
    styleUrls: ['./pcpcalendar.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet]
})
export class PcpcalendarComponent implements OnChanges {
  readonly year = input<number>(undefined);
  readonly month = input<number>(undefined);

  readonly data = input<any[]>(undefined);
  readonly dateKey = input<string>(undefined);
  readonly dayHeight = input<string>('150px');

  readonly dayTempl = contentChild<TemplateRef<any>>("day");

  startDate: Date;
  weeks: number[];

  weekDays = [0, 1, 2, 3, 4, 5, 6];
  weekDayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  ngOnChanges (): void {
      const year = this.year();
      const month = this.month();
      if (year && month) {
          const first = new Date(year, month - 1, 1);
          this.startDate = first.addDays(first.getDay() * -1);

          const numWeeks = (this.startDate.addDays(35).getMonth() + 1) === month ? 6 :
              ((this.startDate.addDays(28).getMonth() + 1) === month ? 5 : 4);
          this.weeks = Array.from(new Array(numWeeks), (x, i) => i);
      }
  }

  getDate (weekNum: number, dayNum: number): Date {
      return this.startDate.addDays((7 * weekNum) + dayNum);
  }

  getData (weekNum: number, dayNum: number): any {
      const dataValue = this.data();
      if (dataValue) {
        const date = this.getDate(weekNum, dayNum);
        const data = dataValue.find((d) => {
            const dataDate = new Date(d[this.dateKey()]);
            return dataDate.getUTCDate() === date.getUTCDate() && dataDate.getUTCMonth() === date.getUTCMonth();              
        });
        return data;
      } 
      return null;
  }

  getDataList (weekNum: number, dayNum: number): any[] {
    const dataValue = this.data();
    if (dataValue) {
      const date = this.getDate(weekNum, dayNum);
      const data = dataValue.filter((d) => {
          const dataDate = new Date(d[this.dateKey()]);
          return dataDate.getUTCDate() === date.getUTCDate() && dataDate.getUTCMonth() === date.getUTCMonth();              
      });
      if (data && data.length > 0){
          return data;
      } else{
        return null;
      }
    }
    return null;
  }  
}
